import ModuleBreakdown from "./moduleBreakdown.component";

export default ModuleBreakdown;
